import React, {Component} from "react";
import { EditorState, RichUtils} from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {request} from "../../../api-client";

export default class RichEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {editorState: EditorState.createEmpty()};
    this.onChange = (editorState) => this.props.onChange(editorState);
    this.setEditor = (editor) => {
      this.editor = editor;
    };
    this.focusEditor = () => {
      if (this.editor) {
        this.editor.focus();
      }
    };
  }

  uploadImage = async (data) => {
    let url = await request.file.image.upload(data, true)

    return new Promise(resolve => {
      resolve({ data: { link: url}})
    })
  }

  render() {
    const { editorState, toolbarOptions } = this.props

    return (
      <div style={this.props.bloomCloudsView ? {margin: '6px 0', minHeight: '250px'} : {margin: '2rem 0'}} onClick={this.focusEditor}>
        <div>
          <div>
            {/*Component docs https://jpuri.github.io/react-draft-wysiwyg/#/docs*/}
            <Editor
              readOnly={this.props.readOnly || false}
              toolbarHidden={this.props.readOnly || false}
              editorRef={this.setEditor}
              editorState={editorState}
              onEditorStateChange={this.onChange}
              wrapperClassName="wrapper-class"
              editorClassName="editor-class"
              toolbarClassName="toolbar-class"
              toolbar={{
                options: toolbarOptions || ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
                image: {
                  uploadEnabled: true,
                  uploadCallback: this.uploadImage,
                  previewImage: true,
                  inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                },
                link: {
                  defaultTargetOption: '_blank',
                },
                inline: toolbarOptions && {
                  options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace'],
                },
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
